var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogoBankRaiffeisen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE600",
    d: "M40 32.44C40 37.3 37.3 40 32.44 40H7.56C2.7 40 0 37.3 0 32.44V7.56C0 2.7 2.7 0 7.56 0h24.89C37.3 0 40 2.7 40 7.56v24.88Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#2B2D34",
    d: "M25.72 18.05v-3.82l1.38-1.38v3.3l1.2 1.2 4.83-4.82 1.19 1.19a8.1 8.1 0 0 0-2.4-5.68c-2.38-2.3-4.96-1.26-5.84-.38l-4.82 4.82 1.23 1.23L20 16.2l-2.5-2.48 1.24-1.23-4.82-4.82c-.88-.88-3.46-1.92-5.84.38a8.1 8.1 0 0 0-2.4 5.68l1.19-1.2 4.83 4.84 1.2-1.2v-3.31l1.38 1.38v3.82L16.22 20l-9.56 9.56 3.78 3.77L20 23.78l9.56 9.56 3.78-3.77L23.78 20l1.94-1.95Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoBankRaiffeisen);
export default ForwardRef;